/**
 * Vista Mis Tags — autoservicio del píxel de seguimiento del Promotor Digital.
 * El promotor pega SU píxel de Meta / GTM (que él contrata y paga) para medir
 * y optimizar sus anuncios. Se guarda en SU nodo (POST /mi-config-marketing).
 * Si no pone ninguno, la landing usa el del operador/central (cascada fractal).
 */

import { t } from '../languages.js';

export function renderTags({ apiGet, apiPost }) {
    const el = document.createElement('div');
    el.innerHTML = `
        <div class="card">
            <h2>${t('tags.titulo')}</h2>
            <p class="pm-tags-desc">${t('tags.descripcion')}</p>

            <label class="pm-field-label">${t('tags.metaPixel')}</label>
            <input type="text" id="pm-meta-pixel" inputmode="numeric" placeholder="${t('tags.metaPlaceholder')}" class="pm-input pm-input-block">

            <label class="pm-field-label">${t('tags.gtm')}</label>
            <input type="text" id="pm-gtm" placeholder="${t('tags.gtmPlaceholder')}" class="pm-input pm-input-block" style="text-transform:uppercase;">

            <div class="error" id="pm-tags-error" style="min-height:18px; margin:8px 0;"></div>
            <button class="btn btn-hero btn-guardar-accent" id="pm-tags-guardar">${t('tags.guardar')}</button>
            <p class="pm-tags-ayuda">${t('tags.ayuda')}</p>
        </div>`;

    const metaEl = el.querySelector('#pm-meta-pixel');
    const gtmEl = el.querySelector('#pm-gtm');
    const errEl = el.querySelector('#pm-tags-error');
    const btn = el.querySelector('#pm-tags-guardar');

    // Cargar los tags actuales.
    apiGet('/api/cashier/mi-config-marketing').then((r) => {
        if (r && r.ok !== false) {
            metaEl.value = r.metaPixelId || '';
            gtmEl.value = r.gtmContainerId || '';
        }
    });

    const REGEX_META = /^\d{6,20}$/;
    const REGEX_GTM = /^GTM-[A-Z0-9]{4,12}$/;

    let enProgreso = false;
    async function guardar() {
        if (enProgreso) return;
        const meta = (metaEl.value || '').trim();
        const gtm = (gtmEl.value || '').trim().toUpperCase();
        errEl.textContent = '';
        if (meta && !REGEX_META.test(meta)) {
            errEl.textContent = t('tags.invalidoMeta');
            return;
        }
        if (gtm && !REGEX_GTM.test(gtm)) {
            errEl.textContent = t('tags.invalidoGtm');
            return;
        }
        enProgreso = true;
        btn.disabled = true;
        const original = btn.textContent;
        try {
            const r = await apiPost('/api/cashier/mi-config-marketing', {
                metaPixelId: meta || null,
                gtmContainerId: gtm || null,
            });
            if (r && r.ok !== false) {
                btn.textContent = '✓ ' + t('tags.guardado');
                setTimeout(() => {
                    btn.textContent = original;
                }, 1500);
            } else {
                errEl.textContent = (r && r.mensaje) || t('common.reintentar');
            }
        } finally {
            enProgreso = false;
            btn.disabled = false;
        }
    }

    btn.addEventListener('click', guardar);
    return el;
}
